import { useRef, useEffect, useState } from "react";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import styles from "./video-highlight.module.css";
import {
  setStartTime,
  setDuration,
} from "../../../Redux/Actions/VideoHighlightAction";
import { useDispatch, useSelector } from "react-redux";
function formatTime(seconds) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
}

function Sliders({
  maxDuration,
  videoRef,
  setSliderValues,
  sliderValues,
  playbackHandleValue,
  setPlaybackHandleValue,
}) {
  const dispatch = useDispatch();
  const [marks, setMarks] = useState([]);
  const [currentPlaybackTime, setCurrentPlaybackTime] = useState(0);
  const sliderRef = useRef(null);
  const [marksReady, setMarksReady] = useState(false);

  const showTrimmer = useSelector(
    (state) => state?.videoHighlightData?.showTrimmer
  );

  const handlePlaybackHandleChange = (value) => {
    videoRef.current.seekTo(value);
  };

  useEffect(() => {
    const calculateMarks = () => {
      const newMarks = [];
      for (let i = 0; i <= maxDuration; i++) {
        const temp = (
          <div key={i} style={{ ...customMarkStyle }}>
            <div
              style={{
                color: "white",
                position: "absolute",
                top: "45px",
                textAlign: "center",
                fontSize: "9px",
                transform: "translateX(-50%)",
              }}
            >
              {formatTime(i)}
            </div>
          </div>
        );
        newMarks.push(temp);
      }
      setMarks(newMarks);
      setMarksReady(true);
    };

    calculateMarks();
  }, [maxDuration]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const videoProgress = videoRef.current?.getCurrentTime();
      setCurrentPlaybackTime(videoProgress);
    }, 100);

    return () => {
      clearInterval(intervalId);
    };
  }, [videoRef]);

  const trimmerTrackStyle = {
    backgroundColor: "#4f83b6",
    height: 35,
    borderRadius: "5px",
    top: "-9px",
  };

  const trimmerHandleStyle = {
    borderColor: "rgba(255, 255, 255, 0.5)",
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    height: 20,
    width: 20,
    borderRadius: "50%",
    ":hover": {
      boxShadow: "none",
    },
    zIndex: 3,
  };

  const trimmerRailStyle = {
    backgroundColor: "transparent",
    height: 50,
    borderRadius: "1px",
  };

  const playbackSliderHandleStyle = {
    borderColor: "red",
    backgroundColor: "whitesmoke",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    height: 60,
    width: 0,
    borderRadius: "1px",
    zIndex: 0,
  };

  const playbackSliderTrackStyle = {
    backgroundColor: "transparent",
    borderRadius: "7px",
  };

  const sliderStyle = {
    width: `${maxDuration * 50}px`,
    borderRadius: "7px",
    height: 10,
  };

  const trimmerStyle = {
    width: `${maxDuration * 50}px`,
    borderRadius: "7px",
    height: 10,
    marginTop: "11px",
  };

  const railStyle = {
    backgroundColor: "#2a2b2a",
    height: 36,
    borderRadius: "10px",
    marginTop: "7px",
  };
  const customMarkStyle = {
    position: "relative",
    top: "-15px",
    width: "1px",
    height: "45px",
    backgroundColor: "black",
    transform: "translateX(-50%)",
  };

  const handleSliderChange = (values) => {
    setPlaybackHandleValue(values[0]);
    videoRef.current.seekTo(values[0]);
    setSliderValues(values);
    setStartTime(dispatch, values[0]);
    setDuration(dispatch, values[1]);
  };

  return (
    maxDuration !== 0 &&
    marksReady && (
      <div className={styles.sliders}>
        {/* Playback Slider */}
        <Slider
          min={0}
          max={maxDuration}
          step={0.1}
          value={currentPlaybackTime}
          onChange={handlePlaybackHandleChange}
          railStyle={railStyle}
          marks={marks}
          handleStyle={playbackSliderHandleStyle}
          trackStyle={playbackSliderTrackStyle}
          style={sliderStyle}
          ref={sliderRef}
        />

        {/* Trimmer Slider */}
        {showTrimmer && (
          <Slider
            min={0}
            max={maxDuration}
            step={0.1}
            range
            value={sliderValues}
            onChange={handleSliderChange}
            trackStyle={trimmerTrackStyle}
            railStyle={trimmerRailStyle}
            handleStyle={[trimmerHandleStyle, trimmerHandleStyle]}
            style={trimmerStyle}
          />
        )}
      </div>
    )
  );
}

export default Sliders;
